import { mapState, mapGetters, mapActions } from 'vuex'

export const memberRegistrationComputed = {
  ...mapState('memberRegistration', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('memberRegistration', ['getStatus', 'getErrors']),
}

export const memberRegistrationMethods = mapActions('memberRegistration', [
  'registrationMember',
  'resetRegistrationMember',
])
